<template>
  <b-sidebar
    :id="drawer.id"
    title="Log Activity"
    backdrop-variant="dark"
    backdrop
    right
    shadow
    no-close-on-backdrop
    no-close-on-esc
    width="620px"
    :visible="drawer.visible"
    sidebar-class="right-drawer white-drawer"
    aria-hidden="false"
    @hidden="onClose"
    @shown="handleDrawerShown"
  >
    <div class="p-2 min-h-full">
      <div class="inline-block absolute top-1/2 right-full rotate-[-90deg] translate-x-[calc(50%-19px)]">
        <BButton
          variant="primary"
          size="small"
          class="whitespace-nowrap trigger-btn"
          @click="onClose"
        >
          LOG ACTIVITY
        </BButton>
      </div>
      <BOverlay
        id="scroll"
        :show="isLoadingActivity"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <div class="space-y-[1.5rem]">
          <div
            v-for="act in activities"
            :key="act.date"
          >
            <p class="mb-[.5rem] uppercase text-[#737373]">
              {{ DAY_DATE_MONTH_YEAR(act.date) }}
            </p>
            <div class="space-y-[.25rem]">
              <div
                v-for="(item, itemIndex) in act.items"
                :key="item.id"
                class="flex flex-wrap items-center gap-x-[.75rem] gap-y-[.25rem]"
                :class="[!getSkNumber(item) ? 'pb-[.75rem]' : '']"
              >
                <div class="inline-block bg-[#F5F5F5] rounded-full aspect-square p-[.5rem]">
                  <feather-icon
                    :icon="getItemIcon(item)"
                    size="18"
                    class="text-[#737373]"
                  />
                </div>
                <p
                  v-if="getActionType(item) === 'CHANGE_PARTNER'"
                  class="mb-0 log-value"
                >
                  <span>{{ getMetadata(item, 'talent_name', 'Nama Talent') }}</span> untuk partner <span>{{
                    getMetadata(item, 'old_partner_name', 'Partner') }}</span> dirubah menjadi <span>{{
                    getMetadata(item, 'new_partner_name', 'Partner') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'CHANGE_TALENT_LEAD'"
                  class="mb-0 log-value"
                >
                  TL <span>{{ getMetadata(item, 'old_talent_lead_name', 'Talent Lead') }}</span> untuk talent <span>{{
                    getMetadata(item, 'talent_name', 'Nama Talent') }}</span> dirubah menjadi <span>TL {{ getMetadata(item, 'new_talent_lead_name', 'Talent Lead') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'CHANGE_TALENT'"
                  class="mb-0 log-value"
                >
                  Talent <span>{{ getMetadata(item, 'old_talent_name', 'Talent') }}</span> untuk <span>{{
                    getMetadata(item, 'partner_name', getMetadata(item, 'old_partner_name', 'Partner')) }}</span>
                  diganti menjadi <span>{{ getMetadata(item, 'new_talent_name', 'Talent') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'CHANGE_DEVICE'"
                  class="mb-0 log-value"
                >
                  Device <span>{{ getMetadata(item, 'talent_name', 'Nama Talent') }}</span> dirubah menjadi <span>{{
                    getMetadata(item, 'new_device_name', 'Device') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'CHANGE_OFFICE'"
                  class="mb-0 log-value"
                >
                  Kantor <span>{{ getMetadata(item, 'talent_name', 'Nama Talent') }}</span> dirubah dari <span>{{
                    getMetadata(item, 'old_office_name', 'Kantor') }}</span> menjadi <span>{{ getMetadata(item, 'new_office_name', 'Kantor') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'UNASSIGN'"
                  class="mb-0 log-value"
                >
                  Talent <span>{{ getMetadata(item, 'talent_name', 'Nama Talent') }}</span> diberhentikan mulai pada
                  tanggal <span>{{ DDMMMMYYYY(getMetadata(item, 'effective_date') || getMetadata(item, 'start_date'))
                  }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'CREATE_ASSIGNMENT'"
                  class="mb-0 log-value"
                >
                  Talent <span>{{ getMetadata(item, 'talent_name', 'Nama Talent') }}</span> di-assign oleh <span>HR
                    Komerce</span> dengan <span>TL {{ getMetadata(item, 'talent_lead_name', 'Talent Lead') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'CHURN_REQUEST'"
                  class="mb-0 log-value"
                >
                  <span>Churn Req</span> untuk talent <span>{{ getMetadata(item, 'talent_name', 'Nama Talent') }}</span>
                </p>
                <p
                  v-else-if="getActionType(item) === 'PARTNER_JOIN'"
                  class="mb-0 log-value"
                >
                  Partner bergabung ke Komtim
                </p>
                <p
                  v-else-if="getActionType(item) === 'DATA_MIGRATION'"
                  class="mb-0 log-value"
                >
                  Data dimigrasikan dari sistem lama.
                </p>
                <span class="ms-auto">{{ item.created_at }} WIB</span>
                <div
                  v-if="getSkNumber(item)"
                  :class="act.items[itemIndex + 1] ? 'border-l' : false"
                  class="p-[.75rem] basis-full ms-[1.1rem]"
                >
                  <div class="bg-[#F5F5F5] rounded-lg p-[.75rem] log-value">
                    SK <BButton
                      variant="light"
                      class="!p-0 !m-[0_0_.1rem_0] hover-link"
                      @click="() => downloadSK({ id: item.metadata.sk_document_id })"
                    >
                      <span class="font-[600]">{{ getSkNumber(item) }}</span>
                    </BButton> ({{ getSkCardText(item) }}) di-generate oleh sistem.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BOverlay>
    </div>
  </b-sidebar>
</template>

<style scoped>
.trigger-btn.btn-primary {
  border-radius: 10px 10px 0 0 !important;
}

p.log-value {
  width: 60%;
}

.log-value {
  color: #737373;
}

.log-value>span {
  color: black;
  font-weight: 600;
}

::v-deep .hover-link:hover {
  background-color: transparent;
  color: #FF6A3A;
  border: transparent 1px solid;
}
</style>

<script>
import { DAY_DATE_MONTH_YEAR, DDMMMMYYYY } from '@/libs/filterDate'
import { komtimAxiosIns } from '@/libs/axios'
import moment from 'moment'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import { showError, SK_CARD_TEXT } from './config'

export default {
  props: {
    drawer: {
      type: Object,
      default: () => ({
        id: 'log-activity-drawer',
        visible: false,
        data: {},
      }),
    },
  },
  data() {
    return {
      isLoadingActivity: false,
      activities: [],
      DAY_DATE_MONTH_YEAR,
      DDMMMMYYYY,
      SK_CARD_TEXT,
    }
  },
  methods: {
    openDrawer() {
      this.drawer.visible = true
    },
    /**
     * Handle close action
     */
    onClose() {
      this.$emit('on-close')
    },
    handleDrawerShown() {
      this.getListActivity()
    },
    getActionType(item) {
      return item ? (item.action_type || '') : ''
    },
    getMetadata(item, key, fallback = '') {
      if (item.metadata && item.metadata[key] !== undefined && item.metadata[key] !== null) {
        return item.metadata[key]
      }
      if (item[key] !== undefined && item[key] !== null) {
        return item[key]
      }
      return fallback
    },
    getSkNumber(item) {
      return this.getMetadata(item, 'sk_number')
    },
    getSkCardText(item) {
      const type = this.getActionType(item)
      return SK_CARD_TEXT[type] || ''
    },
    getItemIcon(item) {
      const type = typeof item === 'string' ? item : this.getActionType(item)
      const tagTypes = [
        'UNASSIGN',
        'CHANGE_TALENT',
        'CHURN_REQUEST',
        'DATA_MIGRATION',
        'PARTNER_JOIN',
      ]
      if (tagTypes.includes(type)) return 'TagIcon'
      return 'FileTextIcon'
    },
    async getListActivity() {
      try {
        this.isLoadingActivity = true
        const url = `/v1/partner_assignments/${this.drawer.data.partnerId}/logs`

        const { data: { data } } = await komtimAxiosIns.get(url)
        const groupedData = data.reduce((acc, item) => {
          if (!item.created_at) return acc
          const d = moment.parseZone(item.created_at)
          const date = d.format('YYYY-MM-DD')
          const time = d.format('HH:mm:ss')

          if (!acc[date]) {
            acc[date] = {
              date,
              items: [],
            }
          }
          acc[date].items.push({
            ...item,
            created_at: time,
          })
          return acc
        }, {})

        this.activities = Object.values(groupedData)
      } catch {
        showError({ title: 'Gagal memuat log activity!' })
      } finally {
        this.isLoadingActivity = false
      }
    },
    async downloadSK({ id }) {
      try {
        const url = `/v1/partner_assignments/sks/${id}/download`
        const response = await komtimAxiosIns.get(url, {
          responseType: 'blob',
        })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const fileName = `SK_${id}.pdf`
        downloadFileFromBlob(blob, fileName)
      } catch (error) {
        showError(error)
      }
    },
  },
}
</script>
